import List from './List'
import Detail from './Detail'
import SectionDetail from './SectionDetail'
import InnerRouter from './InnerRouter'

export default {
  List,
  Detail,
  SectionDetail,
  InnerRouter
}



// WEBPACK FOOTER //
// ./src/common/components/index.js